import React, { Component } from 'react';
import { FormattedText, formatText } from 'core/i18n';
import { isMobile } from 'utilities/browser';
import { Header } from 'components/header/header';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { errorTag } from 'utilities/uTagging';
import { PATH_ERROR_NEW_PRODUCT } from 'constants/uTagConstants/paths';
import { PUBLICA_URL, LOGIN_DESKTOP, LOGIN_MOBILE } from 'constants/index';

class newProductsView extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        errorTag('', PATH_ERROR_NEW_PRODUCT);
    }

    render() {
        const link = formatText('messagesScreen-link');
        const mobileLoginToggleString = isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP;

        return (
            <div className="basic-layering">
                <Header title={formatText('messagesScreen-becomeCustomer')} />
                <div className="main-container messages-main-container">
                    <div className="profesional-data-view">
                        <MessagesScreen
                            iconClass="icons icons--icon-login"
                            title={formatText('messagesScreen-newProductsErrorTitle')}
                            buttonText={formatText('button-understood')}
                            action={function () {
                                window.location.href = PUBLICA_URL + mobileLoginToggleString;
                            }}
                            buttonClass="form__button form__button-secondary"
                        >
                            <FormattedText
                                value="messagesScreen-newProductsErrorInfo"
                                injectedStrings={[PUBLICA_URL + mobileLoginToggleString]}
                            />
                            <FormattedText
                                value="messagesScreen-newProductsErrorInfo2"
                                injectedStrings={[PUBLICA_URL + link]}
                            />
                        </MessagesScreen>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = newProductsView;
